import {
  selectSelectorGenerator,
  writeSelectorGenerator,
} from '../../../pages/typedSelectorHelpers';

const hooks = {
  accountSwitcherViewSubusers: null,
  accountSwitcherBackToParent: null,
  accountSwitcherFriendlyName: null,
  accountSwitcherSubuserBadge: null,
};

const Selectors = selectSelectorGenerator(hooks);
const WriteSelectors = writeSelectorGenerator(hooks);

export { Selectors, WriteSelectors };
